import { configureStore } from '@reduxjs/toolkit'
import credential from './credential'
import site from './site'

const store = configureStore({
  reducer: {
    credential: credential,
    site: site,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
